/**
 * @feature screens
 * @description Contains the reducer and dispatch actions for available screens as well as the custom useScreens hook and types.
 */

export { default as screensInitialState } from './initialState';
export { default as screensReducer } from './reducer';
export { default as useScreens } from './useScreens';
export * from './actions';
export * from './types';